import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('looks_like_you_are_not__o_any_approval_workflow'),
};
